import React, { useState } from 'react'
import Catalog from 'blocks.app/catalog/catalog'
import { EXHIBITIONS_CATALOG_CONFIG, ExhibitionSelectedItems } from '../InstancesCatalogExhibition-types'

export const InstancesCatalogExhibitions = () => {
    const [selectedItems, setSelectedItems] = useState<ExhibitionSelectedItems>([])

    return (
        <Catalog
            type={EXHIBITIONS_CATALOG_CONFIG.type}
            onSelect={setSelectedItems}
            selectedItems={selectedItems}
            treeView={EXHIBITIONS_CATALOG_CONFIG.treeView}
            additionalData={EXHIBITIONS_CATALOG_CONFIG.additionalData}
            fixedHeader={EXHIBITIONS_CATALOG_CONFIG.fixedHeader}
            isExistRightToolbar={EXHIBITIONS_CATALOG_CONFIG.isExistRightToolbar}
            hideHeader={EXHIBITIONS_CATALOG_CONFIG.hideHeader}
        />
    )
}
